<template lang="html">
    <section class="vraag w100 clearfix">
        <div class="question" :class="[required ? 'required' : '']">
            <h4>{{ label }}</h4>
        </div>
         <div class="w50 input" :class="[error ? 'error-radio' : '']">
            <div class="radio inline" v-for="(option, key) in options" :key="key">
                <input
                    type="radio"
                    :id="'rbt-'+ name + '-' + option.label"
                    class="input-radiobutton"
                    :value="option.value"
                    :checked="option.value == value"
                    autocomplete="off"
                    @input="$emit('input', $event.target.value)"
                >
                <label :for="'rbt-'+ name + '-' + option.label" v-html="option.label"></label>
            </div>
            <div class="error-tooltip"><span>{{ error }}</span></div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        name: String,
        label: String,
        options: Array,
        value: String,
        error: String,
        required: Boolean,
    }
}
</script>
